<template>
    <div
        v-if="item"
        :id="'figura-' + item.ID_FIGURA.trim().replaceAll('.', '-')"
        class="figura my-4 flex flex-col border-black-text pb-4"
        :class="{
            'border-b': !isLastPart,
        }"
    >
        <div
            class="mt-4 border-t border-black-text pt-4 font-probold text-base"
        >
            {{ item.ID_FIGURA.trim() }} {{ item.TITULEK }}
        </div>
        <div class="text-base">{{ item.ZDROJ }}</div>
        <Image
            ref="imageRef"
            class="mt-2"
            alt="Image"
            preview
        >
            <template #indicatoricon>
                <i class="pi pi-search" />
            </template>
            <template #image>
                <img
                    class="py-3"
                    :src="previewImageSrc"
                    :alt="`Figura ${item.ID_FIGURA.trim()}`"
                />
            </template>
            <template #preview="slotProps">
                <NuxtLink
                    :to="pdfSrc"
                    target="_blank"
                >
                    <img
                        :src="fullVersionSrc"
                        :alt="`Figura ${item.ID_FIGURA.trim()} - preview`"
                        :style="slotProps.style"
                        class="max-h-[80vh]"
                        @click="slotProps.previewCallback()"
                        @error="
                            $event => {
                                if ($event.target) {
                                    ;($event.target as HTMLImageElement).src =
                                        previewImageSrc
                                }
                            }
                        "
                    />
                </NuxtLink>
            </template>
        </Image>
        <!-- <img
            :src="`${THUMBNAIL_BASE_URL}${locale === 'en' ? '_en' : ''}/${item.ID_FIGURA.trim().split('.')[0]}/_iframe/${item.ID_FIGURA.trim()}_iframe.png`"
            alt="Téma 1"
            class="my-4 w-full"
        /> -->
        <div
            v-if="hasOdkazy"
            class="mt-4 flex items-center gap-4"
        >
            <div>{{ $t("texty.zobrazit_v") }}</div>
            <div class="flex items-center gap-2">
                <NuxtLink
                    v-if="linkToAtlas"
                    :to="linkToAtlas"
                    class="tag border-black-text text-black-text hover:bg-black hover:text-white"
                    >{{ $t("pages.atlas") }}</NuxtLink
                >
                <NuxtLink
                    v-if="linkToKmec"
                    :to="linkToKmec"
                    class="tag border-black-text text-black-text hover:bg-black hover:text-white"
                    >{{ $t("pages.kmec") }}</NuxtLink
                >
                <NuxtLink
                    v-if="linkToKim"
                    :to="linkToKim"
                    class="tag border-black-text text-black-text hover:bg-black hover:text-white"
                    >{{ $t("pages.kim") }}</NuxtLink
                >
                <NuxtLink
                    v-if="linkToKlok"
                    :to="linkToKlok"
                    class="tag border-black-text text-black-text hover:bg-black hover:text-white"
                    >{{ $t("pages.klok") }}</NuxtLink
                >
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { onBeforeRouteLeave } from "vue-router"

const localePath = useLocalePath()
const { locale } = useI18n()
const store = useMainStore()
const { item, isLastPart = false } = defineProps<{
    item: MetadataFigury | undefined
    isLastPart?: boolean
}>()

const imageRef = useTemplateRef("imageRef")

onBeforeRouteLeave(() => {
    // @ts-expect-error:next-line
    if (imageRef.value && imageRef.value.previewVisible) {
        // @ts-expect-error:next-line
        imageRef.value.hidePreview()
        return false
    }
})

onBeforeRouteUpdate(() => {
    // @ts-expect-error:next-line
    if (imageRef.value && imageRef.value.previewVisible) {
        // @ts-expect-error:next-line
        imageRef.value.hidePreview()
        return false
    }
})

const THUMBNAIL_BASE_URL =
    "https://app.iprpraha.cz/apl/mnt/App_UAP/portal/images/figury"

const hasOdkazy = computed(
    () =>
        linkToAtlas.value ||
        linkToKim.value ||
        linkToKmec.value ||
        linkToKlok.value
)

const previewImageSrc = computed(() => {
    return `${THUMBNAIL_BASE_URL}${locale.value === "en" ? "_en" : ""}/WEBP/iframe/${item?.ID_FIGURA.trim().replace("050", "50")}_iframe.webp`
})

const fullVersionSrc = computed(() => {
    return `${THUMBNAIL_BASE_URL}${locale.value === "en" ? "_en" : ""}/WEBP/web/${item?.ID_FIGURA.trim().replace("050", "50")}_web.webp`
})

const pdfSrc = computed(() => {
    return `${THUMBNAIL_BASE_URL}${locale.value === "en" ? "_en" : ""}/PDF/${item?.ID_FIGURA.trim().replace("050", "50")}.pdf`
})

const linkToAtlas = computed(() => {
    if (!item || !item?.ID_SKUPINA_VRSTEV) return null
    let urlParams = ""
    item.ID_SKUPINA_VRSTEV?.split(";").forEach((id, idx) => {
        urlParams += `${idx === 0 ? "?" : "&"}service[]=${id}`
    })
    return localePath(`/mapy/atlas${urlParams}`)
})

const linkToKmec = computed(() => {
    if (!item || !item.ID_METRIKY_KMEC) return null
    return localePath(
        `/cisla/katalog-mestskych-casti/metriky/${item.ID_METRIKY_KMEC}`
    )
})

const linkToKim = computed(() => {
    if (!item || !item.ID_SKUPINY_METRIK_KIM) return null
    return localePath(
        `/cisla/katalog-indikatoru-a-metrik/${item.ID_SKUPINY_METRIK_KIM}`
    )
})
const linkToKlok = computed(() => {
    if (!item || !item.UDAJ_KLOK) return null
    return localePath(`/mapy/katalog-lokalit/?metrika=${item.UDAJ_KLOK}`)
})
</script>

<style scoped>
.figura {
    padding-top: calc(v-bind("store.headerHeight + 'px'") - 1rem);
    margin-top: calc(v-bind("store.headerHeight + 'px'") * -1 + 1rem);
}
</style>
